const i18n_fields = {
  EN: [
    { key: 'id', label: 'No' , thStyle: 'width: 5%'},
    { key: 'ping', label: 'Status', thStyle: 'width: 10%'},
    { key: 'name', label: 'Name', thStyle: 'width: 10%' },
    { key: 'host', label: 'Host' },
    // { key: 'tag', label: 'Tag',  },
    { key: 'os_type', label: 'OS' },
    { key: 'ip_addr', label: 'IP(Public, Private)',},
    { key: 'setting', label: 'Setting'},
    { key: 'select', label: 'Detail' , thStyle: 'width: 10%'}
  ],
  KO : [
    { key: 'id', label: 'No' , thStyle: 'width: 5%'},
    { key: 'ping', label: '상태', thStyle: 'width: 10%'},
    { key: 'name', label: '이름', thStyle: 'width: 10%' },
    { key: 'host', label: '호스트' },
    // { key: 'tag', label: 'Tag',  },
    { key: 'os_type', label: '운영체제' },
    { key: 'ip_addr', label: 'IP(외부, 내부)'},
    { key: 'setting', label: '설정'},
    { key: 'select', label: '더 보기' , thStyle: 'width: 10%'}
  ],
  JP: [
    { key: 'id', label: 'No' , thStyle: 'width: 5%'},
    { key: 'ping', label: 'ステータス', thStyle: 'width: 10%'},
    { key: 'name', label: '名前', thStyle: 'width: 10%' },
    { key: 'host', label: 'ホスト' },
    // { key: 'tag', label: 'タグ',  },
    { key: 'os_type', label: 'OS' },
    { key: 'ip_addr', label: 'IP(Public, Private)',},
    { key: 'setting', label: '設定'},
    { key: 'select', label: '詳細' , thStyle: 'width: 10%'}
  ]
}

const _i18n_info = {
  select: {
    EN: `Select done`,
    KO: `Select done`,
    JP: `完了を選択`
  },
  forgery_check: {
    EN: `no have forgery setting`,
    KO: `no have forgery setting`,
    JP: `偽造防止設定はありません`
  },
  cleared : {
    EN: `cleared`,
    KO: `cleared`,
    JP: `クリアしました`
  }
}

const _i18n_error = {
  folder: {
    EN: `Failed to load folder.`,
    KO: `Failed to load folder.`,
    JP: `フォルダの読み込みに失敗しました`
  },
  get_path  : {
    EN: `Failed to load path.`,
    KO: `Failed to load path.`,
    JP: `パスの読み込みに失敗しました`
  },
  agent_alive: {
    EN: `Required agent online`,
    KO: `Required agent online`,
    JP: `必須のエージェントはオンラインです`
  },
  agent_check: {
    EN: `Specifying a top-level folder (drive) is not recommended`,
    KO: `Specifying a top-level folder (drive) is not recommended`,
    JP: `最上位のフォルダー(ドライブ) を指定することはお勧めできません`
  },
  check: {
    EN: `Need to set folder or file.`,
    KO: `Need to set folder or file.`,
    JP: `フォルダーまたはファイルを設定する必要があります`
  },
}

const _i18n_data = {
  i18n_fields,
  _i18n_info,
  _i18n_error
}

export default _i18n_data